import { useTranslation } from "react-i18next";
import style from "../../sass/pages/auth/auth-page.module.scss";
import { pushAlert } from "../alerts/alertSlice";
import { validateEmail } from "./validates";
import { useDispatch, useSelector } from "react-redux";
import { Link, } from "react-router-dom";
import { resetPasswordThunk, selectResetPasswordError, selectResetPasswordStatus, setAuthenticated, setResetPasswordStatus } from "./authSlice";
import { useEffect, useState } from "react";
import { setPathToAuthentication } from "../path/pathSlice";

const ResetPassword = () => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();

    const error = useSelector(selectResetPasswordError);
    const status = useSelector(selectResetPasswordStatus);

    const [email, setEmail] = useState("");

    const handleButtonClick = async () => {
        let emailErr = validateEmail(email)
        let errors = []
        
        if (emailErr) {
            errors.push(emailErr)
        }
        
        if (errors.length > 0) {
            errors.forEach((err) => {
                dispatch(pushAlert({
                    type: "danger",
                    message: t(err),
                    delay: 2000,
                }))
            })
            return
        }

        dispatch(
            resetPasswordThunk({
                email,
                language: i18n.language,
            })
        );
    };

    useEffect(() => {
        if (!error) {
            return;
        }
        dispatch(pushAlert({
            message: t(error),
            delay: 1000,
            type: "danger"
        }));
    }, [dispatch, error, t]);

    const redirectToAuthentication = () => {
        dispatch(
            setAuthenticated(false)
        )
        dispatch(
            setPathToAuthentication()
        );
        dispatch(
            setResetPasswordStatus(null)
        )
    };

  return (
    <div className={style.container}>
    <main className={style.main}>
        <div className={style.imageBlock}>
            <img src="/static/images/png/profile-image.png" alt="" />
        </div>

        {status !== "fulfilled" && 
        <div className={style.rightBlock}>
            <span className={style.headline}>
                {t("reset_password.header")}
            </span>

            <div className={style.inputBlock}>
                <label className={style.inputLabel}>
                    <div className={style.inputSvgBlock}>
                        <img
                            src="/static/images/svg/email.svg"
                            alt=""
                        />
                    </div>
                    {/* <img src="/static/images/svg/email.svg" alt="" /> */}
                    <input
                        className={style.input}
                        type="text"
                        value={email}
                        placeholder="Email"
                        onInput={(e) => setEmail(e.target.value)}
                    />
                </label>
            </div>

            <button
                className={style.button}
                onClick={handleButtonClick}
            >
                {t("reset_password.reset_button")}
            </button>

            <Link
                onClick={redirectToAuthentication}
                className="mt-4 text-2xs text-gray-600 cursor-pointer"
            >
                {t("reset_password.authentication_link")}
            </Link>
        </div>
        }
        {status === "fulfilled" && 
        <div className={style.rightBlock}>
            <span
                className="text-emerald-600"
            >
                {t("reset_password.success_message")}
            </span>


            <Link
                onClick={redirectToAuthentication}
                className="mt-4 text-2xs text-gray-600 cursor-pointer"
            >
                {t("reset_password.authentication_link")}
            </Link>
        </div>
        }
    </main>
</div>
  )
}

export default ResetPassword